import { useTimer } from '@/features/auth/hooks/useTimer';

type ResendTimerProps = {
  initialSeconds?: number;
  onResend: () => void;
};

function formatTime(time: number) {
  const mins = Math.floor(time / 60);
  const secs = time % 60;
  return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
}

export function ResendTimer({
  initialSeconds = 120,
  onResend,
}: ResendTimerProps) {
  const { seconds, reset } = useTimer(initialSeconds);

  const handleResend = () => {
    onResend();
    reset();
  };

  return (
    <div className="text-center">
      {seconds > 0 ? (
        <p className="m-0 text-sm font-medium text-[#7C8B88]">
          Resend code in{' '}
          <span className="font-semibold text-[#0F1817]">
            {formatTime(seconds)}
          </span>
        </p>
      ) : (
        <button
          type="button"
          onClick={handleResend}
          className="border-none bg-transparent p-0 text-sm font-semibold text-[#119C84] transition-opacity hover:opacity-80"
        >
          Resend OTP
        </button>
      )}
    </div>
  );
}
